import { sva } from '@allenai/varnish-panda-runtime/css';
import type { RecipeVariantProps } from '@allenai/varnish-panda-runtime/types';

const codeBlockRecipe = sva({
    slots: ['root', 'code'],
    base: {
        // these were directly pulled from our varnishPrismTheme
        root: {
            padding: 'var(--allenai-content-markdown-pre-padding)',
            margin: '[.5em 0]',
            overflow: 'auto',
            border: 'none',
            fontSize: '[.9em]',
            lineHeight: '1.2',
        },
        code: {},
    },
    variants: {
        colorMode: {
            light: {
                root: {
                    backgroundColor: 'var(--allenai-content-markdown-code-background-light)',
                },
            },
            dark: {
                root: {
                    backgroundColor: 'var(--allenai-content-markdown-code-background-dark)',
                },
            },
        },
    },
    defaultVariants: {
        colorMode: 'light',
    },
});

type CodeBlockRecipeProps = RecipeVariantProps<typeof codeBlockRecipe>;

export { codeBlockRecipe, codeBlockRecipe as default };
export type { CodeBlockRecipeProps };
